import statesData from 'states-us';

// Single source of truth for US state/territory options across the app.
//
// Both the create form (StateFormSelect) and the site detail view
// (ViewEditSite) used to keep their own lists. They disagreed: StateFormSelect
// offered Puerto Rico while ViewEditSite filtered territories out, so a site
// saved as "Puerto Rico" crashed the detail view on the abbreviation lookup.
// Deriving both from states-us here keeps the names and abbreviations in sync.
//
// We keep the 50 states, DC, and Puerto Rico (the set the create form has
// always offered) and drop the remaining territories.
const US_STATES = statesData
  .filter(state => !state.territory || state.name === 'Puerto Rico')
  .map(state => ({ name: state.name, abbreviation: state.abbreviation }));

export const US_STATE_NAMES = US_STATES.map(state => state.name);

// Look up a state's postal abbreviation by full name. Falls back to the name
// itself for anything not in the list, so legacy/unknown values never throw.
export const abbreviationForState = name => {
  const match = US_STATES.find(state => state.name === name);
  return match ? match.abbreviation : name;
};

export default US_STATES;
